import Vue from 'vue'
import PdfPreviewComponent from './PdfPreview.vue'
import store from '@/store/store'

let instance = null

const PdfPreviewConstructor = Vue.extend(PdfPreviewComponent)

const initInstance = () => {
  instance = new PdfPreviewConstructor({
    el: document.createElement('div'),
    store,
    data() {
      return {
        visible: false,
        pdfUrl: ''
      }
    }
  })
  document.body.appendChild(instance.$el)
}

const PdfPreview = {
  show(url) {
    if (!instance) {
      initInstance()
    }
    instance.pdfUrl = url
    instance.visible = true
  },
  hide() {
    if (instance) {
      instance.visible = false
    }
  }
}

const install = function(Vue) {
  if (install.installed) return
  install.installed = true
  Vue.prototype.$pdfPreview = PdfPreview
}

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
} 


// WEBPACK FOOTER //
// ./src/components/PdfPreview/index.js